import { render } from "./indicatorsDetails.vue?vue&type=template&id=a406b72c&scoped=true"
import script from "./indicatorsDetails.vue?vue&type=script&lang=js"
export * from "./indicatorsDetails.vue?vue&type=script&lang=js"

import "./indicatorsDetails.vue?vue&type=style&index=0&id=a406b72c&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a406b72c"]])

export default __exports__